module.exports = __webpack_public_path__ + "static/img/1072.0ba4356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1072.jpg
// module id = 254
// module chunks = 0